import useSocketReconnect from '../../utils/useSocketReconnect';
import { useState, useEffect } from 'react';
import moment from 'moment';

function DeletedEvents({ socket, autoShow = false }) {
    useSocketReconnect(socket, () => {
        if (show) socket.emit('.request_deleted_events');
    });

    const [deletedEvents, setDeletedEvents] = useState([]);
    const [show, setShow] = useState(autoShow);

    useEffect(() => {
        if (show) {
            socket.emit('.request_deleted_events');
        }
    }, [show]);

    useEffect(() => {
        const onDeletedEvents = events => setDeletedEvents(events.events || []);
        const onDeletedEvent = () => show && socket.emit('.request_deleted_events');
        const onRestoredEvent = () => show && socket.emit('.request_deleted_events');
        socket.on('.deleted_events', onDeletedEvents);
        socket.on('.deleted_event', onDeletedEvent);
        socket.on('.restored_event', onRestoredEvent);
        return () => {
            socket.off('.deleted_events', onDeletedEvents);
            socket.off('.deleted_event', onDeletedEvent);
            socket.off('.restored_event', onRestoredEvent);
        };
    }, [show]);

    const handleRestore = (id) => {
        socket.emit('.restore_event', id);
    };

    if (!show) {
        return (
            <div style={{ marginTop: 20 }}>
                <h3>Paperera d'esdeveniments</h3>
                <button 
                    onClick={() => setShow(true)}
                    style={{
                        backgroundColor: '#4a90d9',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: 6,
                        cursor: 'pointer',
                    }}
                >
                    Mostrar paperera
                </button>
            </div>
        );
    }

    return (
        <div>
            {!autoShow ? (
                <button 
                    onClick={() => setShow(false)}
                    style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: 6,
                        cursor: 'pointer',
                        marginBottom: 10,
                    }}
                >
                    Amagar paperera
                </button>
            ) : null}
            {deletedEvents.length === 0 ? (
                <p style={{ color: '#666', fontStyle: 'italic' }}>No hi ha esdeveniments esborrats.</p>
            ) : (
                <div style={{ marginTop: 10 }}>
                    {deletedEvents.map(ev => (
                        <div key={ev.id} style={{ 
                            border: '1px solid #ddd', 
                            borderRadius: 8, 
                            padding: 12, 
                            margin: '8px 0',
                            backgroundColor: '#fff',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <strong>{ev.title || `Esdeveniment #${ev.id}`}</strong>
                                    <div style={{ color: '#666', fontSize: 14 }}>{moment(ev['data-esperada-inici']).format('DD/MM/YYYY HH:mm')}</div>
                                </div>
                                <button 
                                    onClick={() => handleRestore(ev.id)}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        border: 'none',
                                        padding: '6px 12px',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Restaurar
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default DeletedEvents;
